import { FC, ReactNode, memo } from "react";
import { WarningRhombusIcon } from "~@/icons";

type WarningBannerProps = {
  leading?: ReactNode | undefined;
  action?: ReactNode | undefined;
};

const WarningBanner: FC<WarningBannerProps> = ({ leading, action }) => {
  return (
    <nav className="warning-banner navbar">
      <div className="navbar__menu">
        <div className="navbar__start">
          <div className="navbar__item">
            <div className="icon-text icon-text--has-gap-12">
              <span className="icon">
                <WarningRhombusIcon />
              </span>
              <div className="warning-banner__text">{leading}</div>
            </div>
          </div>
        </div>
        <div className="navbar__end">
          <div className="navbar__item">{action}</div>
        </div>
      </div>
    </nav>
  );
};

export default memo(WarningBanner);
